import React from 'react';
import '../less/main.less';
import Slider from 'react-slick';

export default function template() {
    const {children, modes, isMobile, page, mode, instructionMode} = this.props,
        settings = instructionMode
            ? {
                  autoplaySpeed: 7850,
                  autoplay: true,
                  slidesToScroll: 1,
                  dots: false,
                  variableWidth: true,
                  arrows: false,
                  focusOnSelect: true,
                  infinite: true
              }
            : {
                  centerMode: true,
                  infinite: false,
                  slidesToShow: 1,
                  speed: 500,
                  dots: false,
                  variableWidth: true,
                  arrows: false,
                  slidesToScroll: 1
              },
        btns = modes.map(item => {
            const isSelected = (mode || this.state.mode) === item.mode ? 'selected' : '';
            const title = isSelected ? item.title_active : item.title;
            return instructionMode ? (
                <div
                    key={item.mode}
                    className={`${isSelected} nav-bar-item`}
                    onClick={e => this.toggleMode(e, item.mode)}
                    name={item.mode}
                >
                    <div className="divider" name={item.mode}/>
                    <div className="step" name={item.mode} dangerouslySetInnerHTML={{ __html: this.l10n(item.step) }}/>
                    <div className="title" name={item.mode} dangerouslySetInnerHTML={{ __html: this.l10n(title) }}/>
                    {isSelected ? <div className="text" name={item.mode} dangerouslySetInnerHTML={{ __html: this.l10n(item.text) }}/> : ''}
                </div>
            ) : (
                <button
                    key={item.mode}
                    className={`${isSelected} nav-bar-item  ${item.hidden ? 'hidden' : ''}`}
                    onClick={this.toggleMode}
                    name={item.mode}
                    dangerouslySetInnerHTML={{ __html: this.l10n(item.title) }}
                >
                </button>
            );
        }),
        nav = isMobile ? (
            <div className={`nav-bar ${this.props.page}`}>
                <Slider ref={slider => (this.slider = slider)} {...settings}>{btns}</Slider>
            </div>
        ) : (
            <div className={`nav-bar ${this.props.page}`}>{btns}</div>
        ),
        childrens = children
            ? children.map(item => {
                  return (
                      <div
                          key={item.props.type}
                          className={`${
                              (mode || this.state.mode) === item.props.type
                                  ? 'tab-active'
                                  : 'tab-hidden'
                          } ${item.props.type}`}
                      >
                          {item}
                      </div>
                  );
              })
            : ' ';

    return (
        <>
            {nav}
            <div className={`${page}-content tab-content`}>{childrens}</div>
        </>
    );
}
